/**
 * D325: the Lineage meter. Ordinary play (orders sent, visitors met, chains built, festivals
 * held) adds a little Lineage to it, by `lineage.meter` in the data. It is paid, whole Lineage
 * only, when the world is passed on, alongside the Lineage the generation's Heritage pays, and
 * what is left over carries into the next generation.
 */
import type { IdleContent } from '@hedgerow/data';
import type { IdleWorldState } from './state.ts';

export type IdleLineageDeed = 'order' | 'visitor' | 'chain' | 'festival';

/** The meter as it stands: Lineage, whole and part, this generation's play has added. */
export function idleLineageMeter(state: IdleWorldState): number {
  return state.permanent.lineageMeter ?? 0;
}

/** The world with `deed` added to its Lineage meter. */
export function idleFillLineage(
  state: IdleWorldState,
  content: IdleContent,
  deed: IdleLineageDeed,
): IdleWorldState {
  const add = content.lineage.meter[deed];
  if (add <= 0) return state;
  const lineageMeter = idleLineageMeter(state) + add;
  return { ...state, permanent: { ...state.permanent, lineageMeter } };
}
